import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { components } from 'react-select';

/* Exemplo de uso:
  <Select
    styles={customStyles}
    components={{ DropdownIndicator }}
  />
*/

export const DropdownIndicator = props => {
  const {
    selectProps: { menuIsOpen },
  } = props;

  const iconStyle = {
    transition: 'transform 0.3s ease',
    transform: menuIsOpen ? 'rotate(180deg)' : 'rotate(0deg)',
  };

  return (
    <components.DropdownIndicator {...props}>
      <FaChevronDown style={iconStyle} />
    </components.DropdownIndicator>
  );
};

/*
  MultiValueResumido: renderiza um resumo ("N selecionados") em vez de um chip
  por valor num Select isMulti. Evita overflow em barras de filtro estreitas.
  Uso: <Select isMulti components={{ MultiValue: MultiValueResumido }} />
*/
export const MultiValueResumido = ({ index, getValue }) => {
  if (index > 0) {
    return null;
  }

  const selecionados = getValue() || [];

  if (selecionados.length === 0) {
    return null;
  }

  const texto =
    selecionados.length === 1
      ? selecionados[0].label
      : `${selecionados.length} selecionados`;

  return (
    <div
      style={{
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontSize: '0.875rem',
      }}
    >
      {texto}
    </div>
  );
};

export const customStyles = {
  control: base => ({
    ...base,
    padding: '2px',
    borderRadius: '6px',
    transition: 'all 0.2s ease',
    fontFamily: "'Open Sans', Arial, sans-serif",
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? '#58d0ff' : 'white',
    borderRadius: '6px',
    color: state.isFocused ? 'white' : 'black',
    padding: '10px 12px',
    transition: 'all 0.2s ease',
    fontFamily: "'Open Sans', Arial, sans-serif",
  }),
  menu: base => ({
    ...base,
    padding: '8px',
    zIndex: 9999,
    marginTop: 0,
    fontFamily: "'Open Sans', Arial, sans-serif",
  }),
  menuPortal: base => ({
    ...base,
    zIndex: 99999,
  }),
};
export const selectFormAtividades = {
  control: base => ({
    ...base,
    padding: '2px',
    borderRadius: '4px',
    transition: 'all 0.2s ease',
    fontFamily: "'Open Sans', Arial, sans-serif",
    fontSize: '14px',
    height: '32px',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? '#58d0ff' : 'white',
    borderRadius: '4px',
    color: state.isFocused ? 'white' : 'black',
    padding: '8px 10px',
    transition: 'all 0.2s ease',
    fontFamily: "'Open Sans', Arial, sans-serif",
    fontSize: '14px',
  }),
  menu: base => ({
    ...base,
    padding: '6px',
    zIndex: 9999,
    marginTop: 0,
    fontFamily: "'Open Sans', Arial, sans-serif",
    fontSize: '14px',
  }),
};

export const selectStylesSm = {
  control: (base) => ({
    ...base,
    minHeight: '31px',
    height: '31px',
    fontSize: '0.875rem',
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 6px',
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: '2px 4px',
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: '2px 4px',
  }),
};
